import React from 'react'
import './Invite.css';
import PropTypes from "prop-types";
import Popup from '../popup/Popup';
import config from '../../config';
import { useState } from 'react';

function Invite({invite}) {
    // let inviteStatus = invite.status;
    // let recipientEmail = invite.recipientEmail;
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [copyMessage, setCopyMessage] = useState('Copy URL');


    const popupStaus = async (message) => {
        setPopupMessage(message);
        setShowPopup(true);
    };
        
    const copyInvite = async () => {
        try {
            await navigator.clipboard.writeText(`${config.publicUrl}/invites/accept/${invite.code}`);   
            setCopyMessage('Copied!');
        } catch (error) {
            await popupStaus("An error occured copying the invite. Please try again later.");
        } finally {
            setTimeout(() => {
                setCopyMessage('Copy URL');
            }, 3000);
        }
    };
    

  return (
    <div className='single-invite-container'>
        <Popup isPopupOpen={showPopup} message={popupMessage} button1Text="Close" button1Action={() => setShowPopup(false)} />
        <div className="single-invite-row-container">
            <div className="single-invite-heading">
                <h3 className='invite-status-heading'>Invite status:</h3>
                <p className='invite-status'>{invite.status}</p>
            </div>
            <div className="single-invite-btn-container">
                {invite.status === "available" ? (
                    <button onClick={copyInvite} className='invite-copy-btn'>{copyMessage}</button>
                ) : 
                    <button className='used-invite-copy-btn'>Used</button>
                }
            </div>
        </div>
        <div className="single-invite-seperator-container">
            <hr className='single-invite-seperator'/>
        </div>
    </div>
  )
}

Invite.propTypes = {
    invite: PropTypes.shape({
        code: PropTypes.string,
        status: PropTypes.string,
    })
};

export default Invite;